import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LiveClientUploadEarlyEndpointsClass;
function LiveClientUploadEarlyEndpoints() {
  if (LiveClientUploadEarlyEndpointsClass === VOID) {
    class $ {
      constructor(fetcher, subpath) {
        this.fetcher_1 = fetcher;
        this.subpath_1 = subpath;
      }
    }
    initMetadataForClass($, 'LiveClientUploadEarlyEndpoints', VOID, VOID, VOID, [0, 1]);
    LiveClientUploadEarlyEndpointsClass = $;
  }
  return LiveClientUploadEarlyEndpointsClass;
}
//region block: exports
export {
  LiveClientUploadEarlyEndpoints as LiveClientUploadEarlyEndpoints3jopcpgrbec1u,
};
//endregion

//# sourceMappingURL=LiveClientModelRestEndpoints.mjs.map
